import { render, staticRenderFns } from "./CourseUpdatePage.vue?vue&type=template&id=4d547e5f&scoped=true"
import script from "./CourseUpdatePage.vue?vue&type=script&lang=js"
export * from "./CourseUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./CourseUpdatePage.vue?vue&type=style&index=0&id=4d547e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d547e5f",
  null
  
)

export default component.exports